import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';
import {
  MTAssumptionsSection,
  MTCalc,
  MTCTAv2,
  MTDivider,
  MTHeader,
  MTLearnMore,
  MTLearnMoreItem,
  MTScorePanel,
  MTSkinny,
  MTSubcontent,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentHR,
  MTSubcontentLabel,
  MTSubcontentP,
  MTSubheading,
  MTWide,
} from '../Microtools/layout';
import { CustomCTA } from '../Onboarding/PlanIntro';

import { runFullSimulation } from '../../actions/simulationActions';
import { trackEvent } from '../../actions/trackEventActions';
import { updateFrame } from '../../actions/uiActions';
import { wlPath, wlVar } from '../../helpers/whitelabel';

// for some reason Chrome on Windows needs a bit of extra height (hence +15px)
const IFrameContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: ${props => (props.height ? `${props.height + 15}px` : '100%')};
`;

const StyledIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => `${props.height}px` || '100%'};
  border: 0;
`;

export class InvestorPersonality extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iFrameHeight: undefined,
    };
  }

  componentDidMount() {
    this.props.updateFrame("What's your investor personality?", 'SmilingFaces.png');
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }

    // wait for iFrame to load
    this.checkIfIFrameLoaded();
    //window.addEventListener('resize', this.updateIFrameHeight);
  }

  checkIfIFrameLoaded = () => {
    const iFrame = document.getElementById('calc-iframe');
    const iFrameDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    if (iFrameDoc.readyState === 'complete' && iFrameDoc.getElementsByTagName('body').length) {
      // add a listener that will update the height if it's changed
      this.onElementHeightChange(iFrame, this.updateIFrameHeight);
      this.updateIFrameHeight();
      return;
    }
    window.setTimeout(this.checkIfIFrameLoaded, 100);
  };

  onElementHeightChange = (el, callback) => {
    let lastHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    let newHeight;
    (function run() {
      if (el.contentWindow.document.getElementsByTagName('body').length) {
        newHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
        if (lastHeight != newHeight) {
          callback();
        }
      }

      lastHeight = newHeight;

      if (el.onElementHeightChangeTimer) {
        clearTimeout(el.onElementHeightChangeTimer);
      }

      el.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  };

  updateIFrameHeight = () => {
    this.setState({
      iFrameHeight: this.getIFrameHeight(),
    });
  };

  getIFrameHeight = () => {
    const newiFrameHeight = document
      .getElementById('calc-iframe')
      .contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    return newiFrameHeight;
  };

  componentWillUnmount() {
    //window.removeEventListener('resize', this.updateIFrameHeight);
  }

  render() {
    const { results } = this.props;

    if (!results) {
      return <LoadingBar />;
    }

    return (
      <div>
        <MTHeader title="" onClick={() => history.push(wlPath('/action-plan'))} />
        <MTSkinny>
          <MTSubcontent noCard>
            <MTSubcontentP>
              If the market dropped 20% tomorrow, what would happen to your savings? Would you be comfortable with that
              outcome?
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubheading title="It starts with knowing your personality." />
          <MTSubcontent noCard>
            <MTSubcontentP>
              Successful investors have one thing in common: they have a plan, and they stick to it. But in order to
              stick to a plan when the market is bouncing up and down, you have to be comfortable with the strategy
              you've chosen.
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubcontent noCard>
            <MTSubcontentP>
              That means knowing what your investor personality is, so that you can create a portfolio that reacts the
              way you want it to, both in good times, and bad.
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubcontent noCard>
            <MTSubcontentP>
              <strong>
                Start by finding out your personality type! Then, we can help you find out whether your current
                portfolio matches your needs.
              </strong>
            </MTSubcontentP>
          </MTSubcontent>

          {/* placeholder for iframe */}
          <IFrameContainer height={this.state.iFrameHeight}>
            <StyledIFrame id="calc-iframe" src="/surveys/investor_personality" height={this.state.iFrameHeight} />
          </IFrameContainer>

          <MTSubcontent noCard>
            <MTSubcontentP>
              Once you have your investor personality, you'll be equipped to start designing a strategy that's right for
              you. Get in touch if you'd like us to show you how to make a portfolio that really matches your needs.
            </MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <CustomCTA heading="Let’s create a strategy that fits your style." trackEvent={this.props.trackEvent}>
          <Typography
            tag="div"
            use="body1"
            className="pt-2"
            theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
          >
            Managing your investments can be intimidating at first, but it gets easier when you have back-up. Schedule a
            free intro to walk through your personality results, and start to create a strategy that really works for
            you.
          </Typography>
        </CustomCTA>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    results: state.simulations.results,
  };
}

export default connect(mapStateToProps, { runFullSimulation, trackEvent, updateFrame })(InvestorPersonality);
